import { client } from "./apiClient";
import { setup } from "./setupInterceptors";

setup(client);

export { client };
